var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ trigger: 'hover click focus', content: _vm.category.name }),expression:"{ trigger: 'hover click focus', content: category.name }"}],attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.category.icon))])
}
var staticRenderFns = []

export { render, staticRenderFns }